/* eslint-disable max-len */
import React, { useEffect } from 'react';
import Menubar from '../components/Menubar';
import Footer from '../components/Footer';
import updateMetaDescription from '../components/DescriptTag';
import updateMetaKeywords from '../components/KeywordTag';
import DirCpoContactForm from '../components/DirCpoContactForm';

function NasaSEWP() {
  // Update meta description dynamically
  useEffect(() => {
    // eslint-disable-next-line max-len
    updateMetaDescription('Agile training for private, corporate, and government entities. Become a skilled Product Owner, Scrum Master, Release Train Engineer. Embrace agility and unleash your potential!');
  }, []);

  // Update meta keywords dynamically
  useEffect(() => {
    // eslint-disable-next-line max-len
    updateMetaKeywords('Government training, Individual training, Corporate training');
  }, []);

  return (
    <>
      <Menubar />
      <div className='py-lg-20 pt-14 pb-10 bg-cover ContractVehiclesHeroImage'>
        <div className='container'>
          <div className='row'>
            <div className='col-xl-6 col-lg-7 col-md-8 col-12'>
              <div className='text-white'>
                <h1 className='text-white mb-3 display-4 whiteText-responsive'>
                NASA SEWP VI CONTRACT HOLDER
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid whiteContainer">
        <div className="row pt-3 m-5">
          <div className="col-md-7 col-sm-12">
            <div className="h3 font-weight-bold pb-2">
            Category B – Enterprise-Wide ITC/AV Service Solutions<br/>
            Contract #: 80TECH26D0459
            </div>
            <div className="h3 font-weight-bold pb-2">
            Category C – Mission-Based ITC/AV Service Solutions<br/>
            Contract #: 80TECH26D0136
            </div>
            <div className="">
              <span className='font-weight-bold'>SEWP OVERVIEW</span><br/>
            NASA SEWP VI – The NASA SEWP (Solutions for Enterprise-Wide Procurement),
            pronounced &quot;soup&quot;, provides the latest Information Technology,
            Communication, and Audio-Visual (ITC/AV) solutions andservices for all
            Federal Agencies and their approved contractors. Created in 1993, SEWP I
            was the first Government-Wide Acquisition Contract (GWAC) in the federal
            acquisition space. Originally, the contract vehicle provided only technology
            products for NASA and all other agencies. SEWP has continually evolved over
            the past 30 years, expanding its scope to meet the requests of its customers.
            The SEWP vehicle represents acquisition innovation within the Federal Government.
            The program is self-funded through usage fees (0.34%) and provides all Federal
            agencies with acquisition support - more than 50,000 orders a year.
            </div>
            <div className="pt-4">
              <span className='font-weight-bold'>FAIR OPPORTUNITY</span><br/>
            FAR 16.505(b) (1) provides that each contractor shall be given fair
            opportunity to be considered for each order exceeding $10,000 and
            issued under multiple award contracts. The FAR states that the method
            to obtain fair opportunity is at the discretion of the Contracting
            Officer (CO) and that the CO must document the rationale for placement
            and price of each order. Using the SEWP online Quote Request Tool is
            the recommended method to assist in this activity and to augment the
            required decision documentation. The SEWP Quote Request Tool (QRT)
            will automatically include the Contract Holders within a selected
            Group or based on a suggested source.
            </div>
          </div>
          <div className='col text-center'>
            <img src="./assets/sewp-vi.webp"
              alt="NASA SEWP VI Contract Holder" className="img-fluid"
              width="400" height="400"
            />
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className='row p-5 m-5'>
          <div className='col-md-4'>
            <div className='leadTitleTextBold pt-3 pb-5'>
              Contract Information
            </div>
          </div>
          <div className='col-md-4'>
            <div className='dirSubTitles'>
              Contract Numbers
            </div>
            <div>
              <div className='h3'>
                Category B # 80TECH26D0459
              </div>
              <span className='h3'>
                Category C # 80TECH26D0136
              </span>
            </div>
            <div className='dirSubTitles pt-4'>
              Contract Info
            </div>
            <div className='dirCapaText'>
           Category: A & B<br/>
           Contract Type: GWAC<br/>
           PoP: Nov 1 2026 - Oct 31 2036<br/>
           UEI: WD4UD1FWVYL3<br/>
              <span className='font-weight-bold'>SEWP Contract Holder Information:<br/>
                <a href="https://www.sewp.nasa.gov/sewpvi/chprovider/chcategory/"
                  target='_blank' rel="noreferrer">
                https://www.sewp.nasa.gov/sewpvi/chprovider/chcategory/
                </a>
              </span>
            </div>
          </div>
          <div className='col-md-4'>
            <div className='dirSubTitles'>
              How to Contact SEWP
            </div>
            <div className='dirCapaText'>
              SEWP PMO Hours: Mon-Fri 7:30AM–6PM (ET)<br/>
              Email: <a href="mailto:help@sewp.nasa.gov">help@sewp.nasa.gov</a><br/>
              Customer Help Desk: (301) 286-1478<br/>
              Website: <a href="https://www.sewp.nasa.gov" target='_blank' rel="noreferrer">
                www.sewp.nasa.gov
              </a>
            </div><br/>
            <div className='dirSubTitles'>
              Apppdiction Studio <br/>SEWP Ordering Guide
            </div>
            <div className='dirCapaText'>
              <a href="./assets/NASA_SEWPVI_Ordering_Guide.pdf">
                Click here to download ordering guide</a>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid whiteContainer">
        <div className='row p-5 m-5'>
          <div className='col-md-4'>
            <div className='leadTitleTextBold pt-3 pb-5'>
              Vendor<br/>Contact
            </div>
          </div>
          <div className='col-md-4'>
            <div className='dirSubTitles'>
              Vendor Information
            </div>
            <div>
              <a href="https://appddictionstudio.com" className='h2'>
                Appddiction Studio, LLC
              </a>
            </div>
            <div className='dirSubTitles pt-4 pb-2'>
              Vendor Contact
            </div>
            <div className='vendorContact'>
              <a href="mailto:tporter@appddictionstudio.com" className='h4'>
                <span>Tim Porter&nbsp;</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-box-arrow-up-right" viewBox="0 0 16 16">
                  <path fillRule="evenodd" d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5z"/>
                  <path fillRule="evenodd" d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0v-5z"/>
                </svg>
              </a>
              <br/>
              <div className='h5'>
                Phone (210) 859-9677<br/>
                Fax (210) 570-7936
              </div>
            </div>
          </div>
        </div>
      </div>
      <DirCpoContactForm />
      <Footer/>
    </>
  );
}

export default NasaSEWP;
